import ICONS from "../../../assets/Icons";
import FieldForceTransactionViewAll from "../../../containers/Transactions/FieldForceTransactions/FieldForceTransactionViewAll";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import TEXT from "../../../utils/globalText";
import useCategories from "../../../utils/useCategories";
import CommonLayout from "../../_utils/CommonLayout";
import LargePopupRedirect from "../../_utils/CommonPopups/CommonLargePopupRedirect";
import FormatAmount from "../../_utils/FormatAmount/FormatAmount";
import SVGComponent from "../../_utils/SVGComponent";
import TickerAnimation from "../../_utils/TickerAnimation";
import AdditionalDetailsPreviewMapper from "../../_utils/TransactionCommonComponents/AdditionalDetailsPreviewMapper";
import Amount from "../../_utils/TransactionCommonComponents/Amount";
import CategorySelector from "../../_utils/TransactionCommonComponents/CategorySelector";
import CommonDestinationAccount from "../../_utils/TransactionCommonComponents/CommonDestinationAccount";
import PaymentMethodSelector from "../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import SourceDestinationAccountDetail from "../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";

const FieldForceTxnConfirm = (props) => {
  const categoryMapper = useCategories();
  const categoryIcon = categoryMapper(
    props?.txnPayLoad?.categoryId || props?.selectedCategory?.id,
  );
  const allLabels = [
    ...new Set([
      ...(props?.txnPayLoad?.labels || []),
      ...(props?.txnPayLoad?.ownerLabels || []),
    ]),
  ];

  const normalizedCategories = Array.isArray(props?.txnPayLoad?.mergeCategory)
    ? props.txnPayLoad.mergeCategory
        .map((cat) => {
          if (typeof cat === "string") return cat;
          if (typeof cat === "object" && cat !== null)
            return cat?.name || cat?.category || "";
          return "";
        })
        .map((cat) => cat.trim())
        .filter(Boolean)
    : [];

  return (
    <>
      {props?.showSimilarModal && (
        <div className="fixed z-z-index-modal top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle={"Similar transactions found"}
            headersubtext={
              "Transactions with similar details have already been created. Proceeding will result in a duplicate transaction."
            }
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => props?.setShowSimilarModal(false)}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            confirmbtnrequired={true}
            isbottomSectionneed={true}
            bottomHeaderTextNeed={true}
            btnText="Proceed with caution"
            handleFunction={() => {
              props?.setShowSimilarModal(false);
              props?.onForceCreate();
            }}
            bottomHeaderText={"Proceed with creating this transaction?"}
          >
            <FieldForceTransactionViewAll
              bene_account_name={props?.txnPayLoad?.bankAccountName || "NA"}
              bene_account_id={props?.txnPayLoad?.beneAccountId || null}
              bene_account_confidential={
                props?.txnPayLoad?.beneAccountId || null
              }
              onClose={() => {
                props?.setShowSimilarModal(false);
              }}
              queryParams={props?.queryParams}
              similarTxnType={"similarTxn"}
            />
          </LargePopupRedirect>
        </div>
      )}
      <div className="max-w-tab-width-normal Qsmd:pt-padding-lg py-padding-md px-padding-md Qsmd:px-padding-base">
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <SourceDestinationAccountDetail
              type="source"
              txnPayLoad={props.txnPayLoad}
              setTxnPayLoad={props.setTxnPayLoad}
              page="confirm"
            />
          </div>

          <CommonDestinationAccount
            transactionPayload={props.txnPayLoad}
            setTransactionPayload={props.setTxnPayLoad}
            isReadOnly
            showsBalance={false}
          />

          <div className="flex flex-col gap-gap-md">
            {props?.flow === "PayFieldForceTxn" ? (
              <>
                <div className=" w-full bg-primary-card p-padding-md rounded-border-radius-md">
                  <div>
                    <p className=" text-font-md text-text-primary font-semibold">
                      Category
                    </p>
                  </div>
                  <div
                    className={`rounded-border-radius-md  flex mt-margin-md items-center relative z-z-index-base w-width-full`}
                    style={{ background: "var(--category-background)" }}
                  >
                    <div className=" p-padding-sm flex items-center justify-center rounded-l-border-radius-md">
                      <SVGComponent
                        url={categoryIcon?.url}
                        color={categoryIcon?.colour}
                        height={"var(--icon-lg)"}
                        width={"var(--icon-lg)"}
                      />
                    </div>

                    <div
                      className={`flex relative z-z-index-base 
                    bg-primary-nav
                   rounded-r-border-radius-md flex-1 items-center overflow-hidden`}
                    >
                      <div className="Qmd:w-width-xl w-width-md relative z-z-index-base flex flex-col gap-gap-xs items-center justify-between flex-1 pr-padding-md pl-padding-sm py-padding-sm transition-colors duration-animation-fast-s">
                        <p className="w-width-full text-text-primary font-semibold text-sm break-all mb-request-padding pt-padding-sm pr-padding-xs tracking-letter-space">
                          <TickerAnimation text={props.txnPayLoad.categories} />
                        </p>

                        <p
                          className="w-width-full text-text-primary text-xs pr-padding-xs break-all"
                          style={{
                            visibility: "hidden",
                          }}
                        >
                          <TickerAnimation text={props.txnPayLoad.categories} />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="lg:max-w-[var(--create-box-width)] w-width-full">
                  <CategorySelector
                    previewMode={true}
                    selectedCategory={props?.txnPayLoad?.selectedCategory}
                    category={normalizedCategories}
                    IFSC={props?.txnPayLoad?.bankAccountIFSC}
                    accountNumber={props?.txnPayLoad?.bankAccountNo}
                    beneAccountId={props?.txnPayLoad?.beneAccountId}
                    unassignCategories={[]}
                    unassignlength={[]}
                  />
                </div>
              </>
            )}

            <PaymentMethodSelector
              previewMode={true}
              showUnassignLink={false}
              selectedMethod={props?.txnPayLoad?.settleType}
            />

            <div className="w-width-full h-auto p-padding-md rounded-border-radius-md bg-primary-card">
              <p className="text-left text-base mb-margin-md text-text-primary">
                <span className="font-semibold tracking-letter-space">
                  Labels
                </span>
                <span className="font-normal"> (Optional)</span>
              </p>

              <p className="text-text-primary text-font-sm break-words lg:break-normal lg:whitespace-normal">
                {allLabels?.length === GlobalConfiguration?.lengthCheckZero ? (
                  <span>Not assigned</span>
                ) : (
                  allLabels.map((item, index) => (
                    <span key={index}>
                      {item}
                      {index <
                        allLabels.length - GlobalConfiguration.lengthCheckOne &&
                        ", "}
                    </span>
                  ))
                )}
              </p>

              <p className="text-text-secondary text-font-xs font-normal mt-margin-xs">
                {TEXT?.LABELS}
              </p>
            </div>

            <div className="w-width-full h-auto p-padding-md rounded-border-radius-md bg-primary-card">
              <p className="text-left text-base mb-margin-md text-text-primary">
                <span className="font-semibold tracking-letter-space">
                  Comment
                </span>
                <span className="font-normal"> (Optional)</span>
              </p>

              <p className="text-text-primary text-font-sm break-words">
                {props?.txnPayLoad?.comment?.trim() || "N/A"}
              </p>

              <p className="text-text-secondary text-font-xs font-normal mt-margin-xs">
                Comment
              </p>
            </div>

            {/* Can be use this card later Field force detail card */}
            {/* <div className="w-width-full h-auto p-padding-md rounded-border-radius-md bg-primary-card">
              <p className="text-left text-base mb-margin-md text-text-primary">
                <span className="font-semibold tracking-letter-space">
                  Field Force Details
                </span>
              </p>
              <TitleSubtitlePair
                title={props.txnPayLoad.expenseType || "N/A"}
                subtitle="Expense type"
              />
              <div class="border-b border-primary-bg my-margin-sm"></div>
              <div className="w-width-full flex flex-col gap-gap-xs">
                <p
                  className={`text-font-md text-text-primary overflow-hidden ${"break-all"}`}
                >
                  <div className="flex justify-between items-start gap-gap-sm w-width-full">
                    <div className="flex-1 min-w-min-width-base gap-y-gap-xs flex flex-col">
                      <p className="break-all">
                        {formatDate(new Date(props?.txnPayLoad?.date))}
                      </p>
                      <p className="text-font-xs text-text-secondary">
                        Expense date
                      </p>
                    </div>
                  </div>
                </p>
              </div>
              <div className="border-b border-primary-bg my-margin-sm" />
              <div className="flex justify-between items-start gap-gap-sm w-width-full">
                <TitleSubtitlePair
                  title={props.txnPayLoad.description || "Not given"}
                  subtitle="Description (optional)"
                />
              </div>
              <div class="border-b border-primary-bg my-margin-sm"></div>
              <div className="flex justify-between">
                <TitleSubtitlePair
                  title={
                    props?.flow === "PayFieldForceTxn"
                      ? props?.txnPayLoad?.uploadFile?.metadata?.filename ||
                        "N/A"
                      : props.txnPayLoad.uploadFile.name || "N/A"
                  }
                  subtitle="Upload file"
                />{" "}
                <div className="flex items-center justify-end">
                  {" "}
                  <img
                    src={(() => {
                      const extension =
                        props?.flow === "PayFieldForceTxn"
                          ? (
                              props?.txnPayLoad?.uploadFile?.metadata
                                ?.filename ||
                              props?.txnPayLoad?.uploadFile?.name
                            )
                              ?.split(".")
                              ?.pop()
                              ?.toLowerCase()
                          : props?.txnPayLoad?.uploadFile?.name
                              ?.split(".")
                              ?.pop()
                              ?.toLowerCase();

                      return FileFormatMapper(extension, "confirm");
                    })()}
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src =
                        ICONS?.DEFAULT_FILE;
                    }}
                    alt="file"
                    className="w-icon-lg h-icon-lg shrink-0"
                  />
                </div>
              </div>
            </div> */}
            {/* Can be use this card later Field force detail card */}
          </div>

          <div className="flex flex-col gap-gap-md">
            <div className="bg-primary-card rounded-border-radius-md">
              <Amount
                isPreview={true}
                txnPayLoad={props?.txnPayLoad}
                  requestAmountRequired={true}
              />
              {/* {props?.requestedAmount && (
                <div className="w-full flex flex-col gap-gap-xs px-padding-md py-padding-sm">
                  <p
                    className={`text-font-md font-semibold ${
                      Number(props?.requestedAmount) !==
                      Number(props?.txnPayLoad?.amount)
                        ? "text-queued"
                        : "text-text-primary"
                    }`}
                  >
                    INR <FormatAmount price={props?.requestedAmount} />
                  </p>
                  <p className="text-font-xs text-text-secondary">
                    Requested amount
                  </p>
                </div>
              )} */}
            </div>

            <AdditionalDetailsPreviewMapper
              mappingData={props.txnPayLoad.mergeCategory}
              previewImages={props?.previewImages}
              uploadedFiles={props?.uploadedFiles}
            />
          </div>
        </CommonLayout>

        <div className="h-mobile-create-header w-width-full Qmd:hidden block"></div>
      </div>
    </>
  );
};

export default FieldForceTxnConfirm;
